import { FC, useState } from "react";
import { ReactComponent as MagnifyIcon } from "assets/magnifyingGlass.svg";
import { ReactComponent as CloseIcon } from "assets/close.svg";

import styles from "./ProductForm.module.scss";

interface Props {
  availableProducts: {
    id: number;
    name: string;
    sku: string;
    unit_price: number;
  }[];
  onAddProduct: (productId: number) => void;
  onCancel: () => void;
}

const ProductForm: FC<Props> = ({ availableProducts, onAddProduct, onCancel }) => {
  const [ searchStr, setSearchStr ] = useState("");

  const filter = (p: {name: string, sku: string}) => {
    if (p?.name?.toLowerCase().includes(searchStr.toLowerCase())) {
      return true;
    }
    if (p?.sku?.toLowerCase().includes(searchStr.toLowerCase())) {
      return true;
    }
    return false;
  }

  return (
    <div className={styles["container"]}>
      <div className={styles["search-bar"]}>
        <MagnifyIcon />
        <input
          autoFocus
          value={searchStr}
          onChange={(e) => setSearchStr(e.target.value)}
          type="text"
          className={styles["search-input"]}
        />
        <CloseIcon width={27} onClick={() => setSearchStr("")} />
        <div 
          onClick={() => onCancel()}
          className={styles["cancel-btn"]}>CANCEL</div>
      </div>
      <h6 className={styles["sub-search-bar"]}>
        TOP 5 MATCHES FROM PRODUCT DATABASE
      </h6>
      <ul className={styles["product-list"]}>
        {availableProducts
        .filter(filter)
        .slice(0, 4)
        .map((p, index) => (
          <li onClick={() => onAddProduct(p.id)} key={index}>
            <h5>{p?.name}</h5>
            <span>{p?.sku}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProductForm;